import request from '@/utils/request'

export const getDishBackupFiles = (params) => {
  return request.get('/dishBackup/admin/backups', { params })
}

export const deleteDishBackupFile = (backupNo) => {
  return request.post('/dishBackup/admin/backups/delete', { backup_no: backupNo })
}
